export interface IOrganizationInfo {
  applicationType: string | null;
  assessmentType: string | null;
  companyType: string;
  country: string;
  defaultOperatingCountry: IDefaultOperatingCountry;
  employeeCount: IEmployeeCount;
  id: string;
  legacyId: number;
  name: string;
  organizationMetadatas: IOrganizationMetadata[];
  organizationRegistrationNumbers: IOrganizationRegistrationNumbers[];
  shortName: string | null;
  taxPayerIdNumber: string | null;
  website: string | null;
  countryIso2Code: string;
  parentOrganizationId?: string;
  parentOrganizationName?: string | null;
  isParent: boolean;
  isChild: boolean;
}

interface IDefaultOperatingCountry {
  countryId: string;
  id: string;
  isDefault: true;
  iso2Code: string;
  iso3Code: string;
  name: string;
  organizationId: string;
}

interface IEmployeeCount {
  employeeCount: number;
  subcontractorEmployeeCount: number;
}

export interface IOrganizationMetadata {
  typeId: OrganizationMetadataType;
  value: string | null;
}

export interface IOrganizationRegistrationNumbers {
  typeId: OrganizationRegistrationNumberType;
  value: string | null;
}

export enum OrganizationRegistrationNumberType {
  CompanyRegistrationNumber = 0,
  ABN = 1,
  ACN = 2,
  VATRegistrationNumber = 3,
  FedTaxId = 4,
  ChasMembershipId = 5,
  BusinessShield = 10
}

export enum OrganizationMetadataType {
  BusinessType = 0,
  OrganizationType = 1,
  BusinessSummary = 2,
  AssessmentType = 3,
  CorrelationId = 4,
  CompanyType = 5,
  TradingName = 6,
  PreferredLanguage = 7
}
